import { render, staticRenderFns } from "./notRubbish.vue?vue&type=template&id=4dfa953e"
import script from "./notRubbish.vue?vue&type=script&lang=js"
export * from "./notRubbish.vue?vue&type=script&lang=js"
import style0 from "./notRubbish.vue?vue&type=style&index=0&id=4dfa953e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports